/* Fiducia — comportamento del tema. JavaScript semplice, senza librerie. */
(function () {
  'use strict';

  var theme = window.theme || { routes: {}, strings: {}, delivery: {} };
  var S = theme.strings;

  /* testo tradotto con segnaposto: fmt('Ciao {{ name }}', { name: 'Ivana' }) */
  function fmt(str, vars) {
    return String(str || '').replace(/\{\{\s*(\w+)\s*\}\}/g, function (m, k) { return vars && vars[k] != null ? vars[k] : ''; });
  }
  function $(sel, root) { return (root || document).querySelector(sel); }
  function $$(sel, root) { return Array.prototype.slice.call((root || document).querySelectorAll(sel)); }

  /* ---------------- Cassetti (menu, carrello, filtri) ---------------- */
  var lastFocus = null;
  function openDrawer(id) {
    var d = document.getElementById(id);
    if (!d) return;
    lastFocus = document.activeElement;
    d.classList.remove('is-instant');
    void d.offsetWidth; /* forza lo stato iniziale prima della transizione */
    d.classList.add('is-open');
    d.setAttribute('aria-hidden', 'false');
    document.documentElement.style.overflow = 'hidden';
    $$('[aria-controls="' + id + '"]').forEach(function (b) { b.setAttribute('aria-expanded', 'true'); });
    var focusable = $('.drawer__panel button, .drawer__panel a, .drawer__panel input', d);
    if (focusable) setTimeout(function () { focusable.focus(); }, 30);
  }
  function closeDrawer(d) {
    if (!d) return;
    /* prima si sposta il focus fuori dal cassetto, poi lo si nasconde (aria-hidden su un elemento con il focus non è ammesso) */
    if (d.contains(document.activeElement)) {
      if (lastFocus && lastFocus.focus && document.contains(lastFocus) && !d.contains(lastFocus)) lastFocus.focus({ preventScroll: true });
      if (d.contains(document.activeElement)) document.activeElement.blur();
    }
    d.classList.remove('is-open');
    d.setAttribute('aria-hidden', 'true');
    document.documentElement.style.overflow = '';
    $$('[aria-controls="' + d.id + '"]').forEach(function (b) { b.setAttribute('aria-expanded', 'false'); });
    if (lastFocus && lastFocus.focus) setTimeout(function () { lastFocus.focus({ preventScroll: true }); }, 50);
  }
  document.addEventListener('click', function (e) {
    var opener = e.target.closest('[data-open-drawer]');
    if (opener) { e.preventDefault(); openDrawer(opener.getAttribute('data-open-drawer')); return; }
    var closer = e.target.closest('[data-close-drawer]');
    if (closer) { e.preventDefault(); closeDrawer(closer.closest('.drawer')); return; }
    var cartLink = e.target.closest('[data-open-cart]');
    if (cartLink && document.getElementById('CartDrawer')) { e.preventDefault(); openDrawer('CartDrawer'); }
  });
  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Escape') return;
    $$('.drawer.is-open').forEach(closeDrawer);
    $$('[data-dropdown].is-open').forEach(closeDropdown);
  });

  /* ---------------- Menu a tendina (desktop) ---------------- */
  function closeDropdown(li) { li.classList.remove('is-open'); var b = $('button', li); if (b) b.setAttribute('aria-expanded', 'false'); }
  $$('[data-dropdown]').forEach(function (li) {
    var btn = $('button', li);
    btn.addEventListener('click', function () {
      var open = !li.classList.contains('is-open');
      $$('[data-dropdown].is-open').forEach(closeDropdown);
      if (open) { li.classList.add('is-open'); btn.setAttribute('aria-expanded', 'true'); }
    });
    if (window.matchMedia('(hover: hover)').matches) {
      var t;
      li.addEventListener('mouseenter', function () { clearTimeout(t); $$('[data-dropdown].is-open').forEach(closeDropdown); li.classList.add('is-open'); btn.setAttribute('aria-expanded', 'true'); });
      li.addEventListener('mouseleave', function () { t = setTimeout(function () { closeDropdown(li); }, 180); });
    }
  });
  document.addEventListener('click', function (e) {
    if (!e.target.closest('[data-dropdown]')) $$('[data-dropdown].is-open').forEach(closeDropdown);
  });

  /* ---------------- Finestre (guida taglie, foto ingrandita) ---------------- */
  document.addEventListener('click', function (e) {
    var o = e.target.closest('[data-open-dialog]');
    if (o) {
      var dlg = document.getElementById(o.getAttribute('data-open-dialog'));
      if (dlg && dlg.showModal) { e.preventDefault(); dlg.showModal(); }
      return;
    }
    var c = e.target.closest('[data-close-dialog]');
    if (c) { var d = c.closest('dialog'); if (d) d.close(); return; }
    if (e.target.tagName === 'DIALOG') e.target.close(); /* clic fuori dal riquadro */
  });

  /* ---------------- Galleria prodotto ---------------- */
  $$('[data-gallery]').forEach(function (g) {
    var track = $('[data-gallery-track]', g);
    var slides = $$('[data-gallery-slide]', g);
    var thumbs = $$('[data-gallery-thumb]', g);
    var counter = $('[data-gallery-counter]', g);
    if (!track || !slides.length) return;
    var current = 0;
    function go(i) {
      current = (i + slides.length) % slides.length;
      track.scrollTo({ left: slides[current].offsetLeft, behavior: 'smooth' });
      mark();
    }
    function mark() {
      thumbs.forEach(function (t, k) { t.setAttribute('aria-current', k === current ? 'true' : 'false'); });
      if (counter) counter.textContent = (current + 1) + ' / ' + slides.length;
    }
    var st;
    track.addEventListener('scroll', function () {
      clearTimeout(st);
      st = setTimeout(function () {
        var i = Math.round(track.scrollLeft / track.clientWidth);
        if (i !== current) { current = i; mark(); }
      }, 60);
    });
    var prev = $('[data-gallery-prev]', g), next = $('[data-gallery-next]', g);
    if (prev) prev.addEventListener('click', function () { go(current - 1); });
    if (next) next.addEventListener('click', function () { go(current + 1); });
    thumbs.forEach(function (t) { t.addEventListener('click', function () { go(+t.getAttribute('data-gallery-thumb')); }); });
    track.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowRight') { e.preventDefault(); go(current + 1); }
      if (e.key === 'ArrowLeft') { e.preventDefault(); go(current - 1); }
    });
    /* foto ingrandita, con frecce per passare alle altre foto */
    var lb = document.getElementById('Lightbox');
    var lbImg = lb && $('[data-lightbox-img]', lb);
    var lbCounter = lb && $('[data-lightbox-counter]', lb);
    function showInLightbox(i) {
      var img = $('img', slides[i]);
      if (!img) return;
      var src = img.currentSrc || img.src;
      if (img.getAttribute('width') && img.getAttribute('height')) {
        lbImg.setAttribute('width', img.getAttribute('width'));
        lbImg.setAttribute('height', img.getAttribute('height'));
      }
      lbImg.src = src.replace(/([?&]width=)\d+/, '$11800');
      if (lbCounter) lbCounter.textContent = (i + 1) + ' / ' + slides.length;
      go(i);
    }
    slides.forEach(function (s, i) {
      s.addEventListener('click', function () {
        if (!lb || !lbImg || !lb.showModal) return;
        showInLightbox(i);
        lb.showModal();
      });
    });
    if (lb) {
      $$('[data-lightbox-step]', lb).forEach(function (b) {
        b.addEventListener('click', function () { showInLightbox((current + +b.getAttribute('data-lightbox-step') + slides.length) % slides.length); });
      });
      lb.addEventListener('keydown', function (e) {
        if (slides.length < 2) return;
        if (e.key === 'ArrowRight') { e.preventDefault(); showInLightbox((current + 1) % slides.length); }
        if (e.key === 'ArrowLeft') { e.preventDefault(); showInLightbox((current - 1 + slides.length) % slides.length); }
      });
    }
  });

  /* ---------------- Consegna stimata ---------------- */
  function addBusinessDays(date, n) {
    var d = new Date(date);
    while (n > 0) {
      d.setDate(d.getDate() + 1);
      var w = d.getDay();
      if (w !== 0 && w !== 6) n--;
    }
    return d;
  }
  /* "Ordina ora: spedito entro <data>": giorni lavorativi di spedizione dalle impostazioni, saltando i weekend.
     Con 0 giorni: in giornata se si ordina prima dell'orario limite, altrimenti il primo giorno lavorativo dopo. */
  $$('[data-delivery-text]').forEach(function (el) {
    var cfg = theme.delivery || {};
    var now = new Date();
    var day = now.getDay();
    var n = +cfg.shipDays || 0;
    var ship;
    if (n > 0) ship = addBusinessDays(now, n);
    else ship = (day === 0 || day === 6 || now.getHours() >= (cfg.cutoffHour || 13)) ? addBusinessDays(now, 1) : now;
    try {
      var df = new Intl.DateTimeFormat(theme.locale || 'it', { weekday: 'long', day: 'numeric', month: 'long' });
      el.innerHTML = fmt(S.shipEstimate, { date: df.format(ship) });
    } catch (err) { /* resta il testo di base */ }
  });

  /* ---------------- Soldi ---------------- */
  function money(cents) {
    var v = (cents / 100).toFixed(2).split('.');
    var int = v[0].replace(/\B(?=(\d{3})+(?!\d))/g, '.');
    var out = int + ',' + v[1];
    var fmt = theme.moneyFormat || '{{amount_with_comma_separator}} €';
    return fmt.replace(/\{\{\s*\w+\s*\}\}/, out);
  }

  /* ---------------- Carrello: aggiornamento sezioni ---------------- */
  function sectionIds() {
    var ids = [];
    var drawer = $('[data-cart-drawer]');
    if (drawer) ids.push(drawer.getAttribute('data-section-id'));
    var page = $('[data-cart-page]');
    if (page) ids.push(page.getAttribute('data-section-id'));
    return ids;
  }
  function renderSections(sections) {
    if (!sections) return;
    var drawerWasOpen = !!$('#CartDrawer.is-open');
    Object.keys(sections).forEach(function (id) {
      var html = sections[id];
      if (!html) return;
      var wrap = document.getElementById('shopify-section-' + id);
      var doc = new DOMParser().parseFromString(html, 'text/html');
      var fresh = doc.getElementById('shopify-section-' + id) || doc.body;
      if (wrap) wrap.innerHTML = fresh.innerHTML;
    });
    if (drawerWasOpen) {
      var d = document.getElementById('CartDrawer');
      if (d) {
        d.classList.add('is-instant', 'is-open');
        d.setAttribute('aria-hidden', 'false');
        requestAnimationFrame(function () { requestAnimationFrame(function () { d.classList.remove('is-instant'); }); });
      }
    }
    updateCount();
  }
  function updateCount(count) {
    if (typeof count !== 'number') {
      var drawer = $('[data-cart-drawer]');
      if (!drawer) return;
      count = +drawer.getAttribute('data-item-count');
    }
    $$('[data-cart-count]').forEach(function (el) {
      var changed = String(el.textContent).trim() !== String(count);
      el.textContent = count;
      el.setAttribute('data-count', count);
      if (changed) {
        el.classList.remove('is-bumping');
        void el.offsetWidth;
        el.classList.add('is-bumping');
      }
    });
  }
  function postJSON(url, body) {
    return fetch(url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: JSON.stringify(body)
    }).then(function (r) {
      return r.json().then(function (data) { if (!r.ok) { var e = new Error(data.description || data.message || S.errorGeneric); e.data = data; throw e; } return data; });
    });
  }
  /* messaggio breve sotto una riga del carrello (cassetto e pagina) */
  function lineNotice(line, text) {
    $$('.cart-lines').forEach(function (list) {
      var li = list.children[line - 1];
      var body = li && li.children[1];
      if (!body) return;
      var old = $('.cart-line__msg', body);
      if (old) old.remove();
      var p = document.createElement('p');
      p.className = 'cart-line__msg';
      p.setAttribute('role', 'status');
      p.textContent = text;
      body.appendChild(p);
    });
  }
  function changeLine(line, qty) {
    $$('.cart-lines').forEach(function (l) { l.classList.add('is-loading'); });
    return postJSON((theme.routes.cartChange || '/cart/change') + '.js', { line: line, quantity: qty, sections: sectionIds(), sections_url: window.location.pathname })
      .then(function (cart) {
        if (!cart.sections) { location.reload(); return; }
        renderSections(cart.sections);
        /* Shopify non va oltre i pezzi disponibili: lo diciamo, invece di non fare nulla */
        var item = cart.items && cart.items[line - 1];
        if (qty > 0 && item && item.quantity < qty) lineNotice(line, fmt(S.maxQty, { count: item.quantity }));
      })
      .catch(function (err) {
        /* niente finestre del browser: si torna alla quantità di prima e si spiega sotto la riga */
        $$('.cart-lines').forEach(function (l) { l.classList.remove('is-loading'); });
        $$('[data-qty-input][data-line="' + line + '"]').forEach(function (i) { i.value = i.defaultValue; });
        lineNotice(line, err.message || S.errorGeneric);
      });
  }
  document.addEventListener('click', function (e) {
    var step = e.target.closest('[data-qty-change]');
    if (step) {
      var box = step.closest('[data-qty]');
      var input = $('[data-qty-input]', box);
      var q = Math.max(0, (+input.value || 0) + (+step.getAttribute('data-qty-change')));
      input.value = q;
      changeLine(+input.getAttribute('data-line'), q);
      return;
    }
    var rm = e.target.closest('[data-line-remove]');
    if (rm) { changeLine(+rm.getAttribute('data-line-remove'), 0); }
  });
  document.addEventListener('change', function (e) {
    var input = e.target.closest('[data-qty-input]');
    if (input) changeLine(+input.getAttribute('data-line'), Math.max(0, +input.value || 0));
  });

  /* ---------------- Modulo prodotto ---------------- */
  $$('[data-product]').forEach(function (root) {
    var form = $('form.product-form', root);
    if (!form) return;
    var hiddenId = $('[data-variant-input]', form);
    function currentId() {
      var r = $('[data-variant-radio]:checked', form);
      if (r) return r.value;
      return hiddenId ? hiddenId.value : '';
    }
    var radios = $$('[data-variant-radio]', form);
    var stock = $('[data-stock-line]', form);
    var errorBox = $('[data-form-error]', form);
    var addBtn = $('[data-add-to-cart]', form);
    var buyNow = $('[data-buy-now]', form);
    var selectedLabel = $('[data-selected-size]', form);
    var picker = $('[data-size-picker]', form);
    var low = +root.getAttribute('data-low-stock') || 0;
    var sticky = $('[data-sticky-atc]');
    var stickyPrice = sticky && $('[data-sticky-price]', sticky);
    var stickyBtn = sticky && $('[data-sticky-button]', sticky);

    function showError(msg) { errorBox.textContent = msg; errorBox.hidden = false; }
    function clearError() { errorBox.hidden = true; errorBox.textContent = ''; }

    function selectRadio(r) {
      clearError();
      if (selectedLabel) selectedLabel.textContent = r.getAttribute('data-title');
      var legend = picker && $('legend span', picker);
      if (legend && legend.textContent.indexOf(S.chooseSize) === 0) legend.textContent = legend.textContent.replace(S.chooseSize, S.sizeLabel);
      var qty = +r.getAttribute('data-qty');
      stock.className = 'stock-line';
      if (r.getAttribute('data-available') !== 'true') {
        stock.classList.add('stock-line--out'); stock.textContent = S.sizeSoldOut;
      } else if (low > 0 && qty <= low) {
        stock.classList.add('stock-line--low');
        stock.textContent = qty === 1 ? S.lowStockOne : fmt(S.lowStockOther, { count: qty });
      } else {
        /* stessa icona della riga stampata dal server */
        var okIcon = $('[data-icon-ok]', form);
        stock.classList.add('stock-line--ok');
        stock.innerHTML = okIcon ? okIcon.innerHTML : '';
        stock.appendChild(document.createTextNode(' ' + S.inStock));
      }
      var price = +r.getAttribute('data-price');
      var cur = $('[data-price-current]', root);
      if (cur) cur.textContent = money(price);
      if (stickyPrice) stickyPrice.textContent = money(price);
      if (stickyBtn) stickyBtn.textContent = S.addToCart;
      try {
        var url = new URL(window.location.href);
        url.searchParams.set('variant', r.value);
        history.replaceState(null, '', url.toString());
      } catch (err) {}
    }
    radios.forEach(function (r) {
      r.addEventListener('change', function () { if (r.checked) selectRadio(r); });
    });

    function needSize() {
      if (currentId()) return false;
      showError(S.selectSizeFirst || S.chooseSize);
      if (picker) {
        picker.scrollIntoView({ behavior: 'smooth', block: 'center' });
        var first = radios.filter(function (r) { return !r.disabled; })[0];
        if (first) setTimeout(function () { first.focus({ preventScroll: true }); }, 350);
      }
      return true;
    }

    function add(after) {
      if (needSize()) return;
      clearError();
      addBtn.disabled = true;
      var label = $('[data-add-label]', addBtn);
      var old = label ? label.textContent : '';
      if (label) label.textContent = S.adding;
      postJSON((theme.routes.cartAdd || '/cart/add') + '.js', {
        items: [{ id: +currentId(), quantity: 1 }],
        sections: sectionIds(),
        sections_url: window.location.pathname
      }).then(function (res) {
        if (after === 'checkout') { window.location.href = theme.routes.checkout || '/checkout'; return; }
        renderSections(res.sections);
        var msg = $('[data-added-msg]');
        if (msg) {
          var title = $('.product__title', root);
          var picked = $('[data-variant-radio]:checked', form);
          var pname = title ? title.textContent.trim() : '';
          var text = picked ? fmt(S.addedItemSize, { product: pname, size: picked.getAttribute('data-title') }) : fmt(S.addedItem, { product: pname });
          var span = $('[data-added-text]', msg);
          if (span) span.textContent = text;
          msg.hidden = false;
        }
        requestAnimationFrame(function () { openDrawer('CartDrawer'); });
      }).catch(function (err) {
        showError(err.message || S.errorGeneric);
      }).then(function () {
        addBtn.disabled = false;
        if (label) label.textContent = old;
      });
    }

    form.addEventListener('submit', function (e) { e.preventDefault(); add(); });
    if (buyNow) buyNow.addEventListener('click', function () { add('checkout'); });

    if (sticky && addBtn) {
      stickyBtn.textContent = currentId() ? S.addToCart : S.chooseSize;
      /* la barra compare quando il pulsante principale è passato sopra lo schermo.
         Si controlla allo scorrimento (non con IntersectionObserver): così funziona anche con un salto
         veloce in fondo alla pagina o quando il browser riapre la pagina già scorsa. */
      var stickyTick = false;
      function updateSticky() {
        stickyTick = false;
        var show = addBtn.getBoundingClientRect().bottom < 0;
        if (show === sticky.classList.contains('is-visible')) return;
        sticky.classList.toggle('is-visible', show);
        sticky.setAttribute('aria-hidden', show ? 'false' : 'true');
        document.body.classList.toggle('has-sticky-atc', show); /* il pulsante WhatsApp sale sopra la barra */
        stickyBtn.tabIndex = show ? 0 : -1;
      }
      function queueSticky() { if (!stickyTick) { stickyTick = true; requestAnimationFrame(updateSticky); } }
      window.addEventListener('scroll', queueSticky, { passive: true });
      window.addEventListener('resize', queueSticky);
      updateSticky();
      stickyBtn.addEventListener('click', function () {
        if (currentId()) add(); else needSize();
      });
    }
  });

  /* ---------------- Prodotti consigliati ---------------- */
  $$('[data-recommendations]').forEach(function (el) {
    var url = el.getAttribute('data-url');
    if (!url || el.children.length) return;
    fetch(url).then(function (r) { return r.text(); }).then(function (html) {
      var doc = new DOMParser().parseFromString(html, 'text/html');
      var fresh = doc.querySelector('[data-recommendations]');
      if (fresh && fresh.innerHTML.trim()) el.innerHTML = fresh.innerHTML;
    }).catch(function () {});
  });

  /* ---------------- Filtri e ordinamento ---------------- */
  document.addEventListener('change', function (e) {
    var el = e.target.closest('[data-auto-submit]');
    if (!el) return;
    var f = el.form;
    if (f) { if (f.requestSubmit) f.requestSubmit(); else f.submit(); }
  });
  /* invia solo i campi compilati, per indirizzi puliti */
  document.addEventListener('submit', function (e) {
    var f = e.target;
    if (!f.matches('[data-filters-form], [data-sort-form]')) return;
    $$('input', f).forEach(function (i) { if ((i.type === 'number' || i.type === 'hidden') && i.value === '') i.disabled = true; });
  });

  /* ---------------- La tua taglia: ricordata dalla collezione, evidenziata nella scheda prodotto ---------------- */
  var SIZE_KEY = 'naya-taglia';
  document.addEventListener('click', function (e) {
    var chip = e.target.closest('[data-size-chip]');
    if (!chip) return;
    try { if (chip.classList.contains('is-active')) localStorage.removeItem(SIZE_KEY); else localStorage.setItem(SIZE_KEY, chip.getAttribute('data-size-chip')); } catch (err) {}
  });
  (function markYourSize() {
    var saved = null;
    try { saved = localStorage.getItem(SIZE_KEY); } catch (err) {}
    if (!saved) return;
    $$('[data-variant-radio]').forEach(function (r) {
      if (r.getAttribute('data-title') !== saved || r.disabled) return;
      var label = document.querySelector('label[for="' + r.id + '"]');
      if (!label || label.querySelector('.size-yours')) return;
      label.classList.add('is-yours');
      var tag = document.createElement('small');
      tag.className = 'size-yours';
      tag.textContent = S.yourSize || '';
      label.appendChild(tag);
    });
  })();

  /* ---------------- Lingua e paese: rilevamento e suggerimento ----------------
     Shopify sa da quale paese arriva il visitatore (browsing_context_suggestions.json).
     Se la lingua giusta per lui non è quella della pagina, gli proponiamo di cambiarla,
     con un avviso scritto nella SUA lingua. La scelta resta salvata nel browser. */
  var GEO_KEY = 'naya-lingua';
  var GEO_TEXT = {
    it: { text: 'Questo sito è disponibile anche in italiano.', yes: 'Vai alla versione italiana', no: 'No, grazie' },
    de: { text: 'Diese Seite gibt es auch auf Deutsch.', yes: 'Auf Deutsch ansehen', no: 'Nein, danke' },
    fr: { text: 'Ce site existe aussi en français.', yes: 'Voir en français', no: 'Non, merci' },
    es: { text: 'Esta web también está en español.', yes: 'Ver en español', no: 'No, gracias' }
  };
  function geoRead() { try { return JSON.parse(localStorage.getItem(GEO_KEY) || 'null'); } catch (e) { return null; } }
  function geoSave(choice, lang) { try { localStorage.setItem(GEO_KEY, JSON.stringify({ choice: choice, lang: lang, at: Date.now() })); } catch (e) {} }

  /* chi cambia lingua a mano non riceve più suggerimenti */
  document.addEventListener('submit', function (e) {
    var f = e.target;
    if (!f.classList || !f.classList.contains('localization-form')) return;
    var btn = e.submitter;
    var lang = (btn && btn.name === 'language_code' && btn.value) || ($('[name="language_code"]', f) || {}).value;
    geoSave('manual', lang || '');
  });

  (function geoSuggest() {
    var g = theme.geo;
    var box = $('[data-geo-banner]');
    if (!g || !box || g.mode === 'off' || !window.fetch) return;
    if (navigator.webdriver || /bot|crawl|spider|slurp|facebookexternalhit|lighthouse|headless|preview/i.test(navigator.userAgent)) return;
    var saved = geoRead();
    if (saved && (saved.choice === 'manual' || saved.choice === 'no')) return;
    var form = $('form', box);
    function go(lang, country, auto) {
      /* al massimo un cambio automatico per sessione: niente giri infiniti se la lingua non è attiva */
      if (auto) { try { if (sessionStorage.getItem(GEO_KEY) === lang) return; sessionStorage.setItem(GEO_KEY, lang); } catch (e) { return; } }
      var li = $('[data-geo-language]', form), ci = $('[data-geo-country]', form);
      li.value = lang;
      if (country && g.countries.indexOf(country) !== -1) ci.value = country; else ci.disabled = true;
      form.submit();
    }
    /* ha già accettato una lingua: se arriva su una pagina in un'altra lingua (es. un link italiano), lo riportiamo alla sua */
    if (saved && saved.choice === 'yes' && saved.lang && saved.lang !== g.language && g.languages.indexOf(saved.lang) !== -1) {
      go(saved.lang, null, true);
      return;
    }
    var q = '/browsing_context_suggestions.json?country[enabled]=true&country[exclude]=' + encodeURIComponent(g.country || '') +
      '&language[enabled]=true&language[exclude]=' + encodeURIComponent(g.language || '');
    fetch(q, { headers: { Accept: 'application/json' }, credentials: 'same-origin' })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (data) {
        if (!data || !data.suggestions) return;
        var pick = null;
        data.suggestions.some(function (sg) {
          var l = sg.parts && sg.parts.language && sg.parts.language.handle;
          if (l) l = String(l).toLowerCase().split('-')[0];
          if (l && l !== g.language && g.languages.indexOf(l) !== -1) { pick = { lang: l, country: sg.parts.country && sg.parts.country.handle }; return true; }
          return false;
        });
        if (!pick) return;
        if (!pick.country && data.detected_values && data.detected_values.country) pick.country = data.detected_values.country.handle;
        if (g.mode === 'redirect' && !saved) { geoSave('yes', pick.lang); go(pick.lang, pick.country, true); return; }
        var t = GEO_TEXT[pick.lang] || GEO_TEXT.it;
        var text = $('[data-geo-text]', box);
        text.textContent = t.text;
        text.setAttribute('lang', pick.lang);
        $('[data-geo-yes]', box).textContent = t.yes;
        $('[data-geo-yes]', box).setAttribute('lang', pick.lang);
        var no = $('.geo-banner__actions [data-geo-no]', box);
        no.textContent = t.no;
        no.setAttribute('lang', pick.lang);
        box.hidden = false;
        requestAnimationFrame(function () { box.classList.add('is-visible'); });
        $('[data-geo-yes]', box).addEventListener('click', function () { geoSave('yes', pick.lang); go(pick.lang, pick.country); });
        $$('[data-geo-no]', box).forEach(function (b) {
          b.addEventListener('click', function () { geoSave('no', g.language); box.classList.remove('is-visible'); setTimeout(function () { box.hidden = true; }, 250); });
        });
      })
      .catch(function () {});
  })();
})();
